import React from 'react';
// tslint:disable-next-line
const customActionClose = require('./actionClose.svg');
function CustomActionClose() {
    return React.createElement("img", { src: customActionClose });
}
export default CustomActionClose;
